"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function isLocal() {
  return window.location.origin.indexOf('localhost') > -1 || window.location.origin.indexOf('127.0.0') > -1;
}
var _default = isLocal;
exports["default"] = _default;